import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import ShareIcon from "@mui/icons-material/Share";

const ButtonGroupComponent = ({ onPrint, onShare, isDoneClicked }) => {
  const isMobileOrTab = useMediaQuery("(max-width:1024px)");

  const handlePrint = () => {
    if (onPrint) {
      onPrint();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      alignItems: "center",
      padding: "10px",
      marginLeft: isMobileOrTab ? 0 : "1100px",
      marginTop: isMobileOrTab ? 0 : "-150px",
      width: isMobileOrTab ? "100vw" : "auto",
    }}>
      <div style={{ display: "flex", gap: "8px", width: isMobileOrTab ? "100vw" : "auto" }}>
        <Button
          variant="contained"
          style={{
            backgroundColor: "#1E201E",
            color: "white",
            fontWeight: "bold",
            padding: "8px",
            fontSize: isMobileOrTab ? "14px" : "17px",
            textTransform: "none",
            fontFamily: "'PT Serif', serif",
            borderRadius: "5px",
            width: isMobileOrTab ? "90vw" : "300px",
            height: isMobileOrTab ? "36px" : "40px",
            marginLeft: isMobileOrTab ? "40px" : 0, // <-- Add this line
          }}
          startIcon={<ShareIcon style={{ fontSize: isMobileOrTab ? "22px" : "30px" }} />}
          onClick={onShare}
        >
          SHARE
        </Button>
      </div>
      <Button
        variant="contained"
        style={{
          backgroundColor: "#20a4a5",
          color: "black",
          fontWeight: "bold",
          fontSize: isMobileOrTab ? "22px" : "38px",
          fontFamily: "Caladea, serif",
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          borderRadius: "5px",
          width: isMobileOrTab ? "90vw" : "300px",
          height: isMobileOrTab ? "60px" : "70px",
          border: "2px solid black",
        }}
        startIcon={<PrintIcon style={{ fontSize: isMobileOrTab ? "22px" : "35px" }} />}
        onClick={handlePrint}
        disabled={!isDoneClicked}
      >
        PRINT
      </Button>
    </div>
  );
};

export default ButtonGroupComponent;